class ReviewsList extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setAttribute('data-initialized', 'true')
  }

  setupListeners () {
    super.setupListeners()

    this.toggleReviews = this.toggleReviews.bind(this)

    if (this.els.button.element) {
      this.listeners.add(this.els.button.element, 'click', this.toggleReviews)
    }

    this.setListHeight()
    this.checkButtonVisibility()

    this.handleResize = this.handleResize.bind(this)
    window.addEventListener('resize', this.handleResize)
  }

  disconnectedCallback () {
    super.disconnectedCallback()

    window.removeEventListener('resize', this.handleResize)
  }

  setListHeight () {
    if (window.innerWidth >= 901) {
      this.els.list.element.style.maxHeight = 'unset'
      this.els.list.element.style.overflowY = 'unset'

      this.style.maxHeight = '100vh'
      this.style.overflowY = 'auto'
      return
    }

    this.style.maxHeight = 'unset'
    this.style.overflowY = 'unset'
    this.els.list.element.style.maxHeight = '600px'
    this.els.list.element.style.overflowY = 'auto'
  }

  checkButtonVisibility () {
    if (!this.els.button.element) return

    const allReviews = this.els.list.element.querySelectorAll(
      '.sec-ImageAndReviews_Review',
    )
    const initialCount = this.getAttribute('data-initial-reviews')
    const shouldShowButton =
      allReviews.length > initialCount && window.innerWidth <= 900

    if (shouldShowButton) {
      this.els.button.element.parentElement.style.display = 'block'
    } else {
      this.els.button.element.parentElement.style.display = 'none'
    }
  }

  toggleReviews () {
    const hiddenReviews = this.els.list.element.querySelectorAll(
      '.sec-ImageAndReviews_Review-hidden',
    )
    const isExpanded = hiddenReviews.length === 0

    if (isExpanded) {
      const allReviews = this.els.list.element.querySelectorAll(
        '.sec-ImageAndReviews_Review',
      )
      const initialCount = this.getAttribute('data-initial-reviews')

      allReviews.forEach((review, index) => {
        if (index >= initialCount) {
          review.classList.add('sec-ImageAndReviews_Review-hidden')
        }
      })

      this.setListHeight()
    } else {
      hiddenReviews.forEach((review) => {
        review.classList.remove('sec-ImageAndReviews_Review-hidden')
      })

      const listHeight = this.els.list.element.scrollHeight
      this.els.list.element.style.maxHeight = `${listHeight}px`
      this.els.list.element.style.overflowY = 'auto'
    }

    const newHiddenReviews = this.els.list.element.querySelectorAll(
      '.sec-ImageAndReviews_Review-hidden',
    )
    this.els.buttonText.element.textContent =
      newHiddenReviews.length === 0
        ? window.theme.strings.showLessReviews
        : window.theme.strings.showMoreReviews

    this.checkButtonVisibility()
  }

  handleResize () {
    this.setListHeight()
    this.checkButtonVisibility()
  }
}
if (!customElements.get('reviews-list')) {
  customElements.define('reviews-list', ReviewsList)
}
